import { faWhatsapp } from "@fortawesome/free-brands-svg-icons/faWhatsapp";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons/faEnvelope";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Button } from "../../../../components/Button";
import { CopyButton } from "../../../../components/CopyButton";
import { TestIDs } from "../../../../tests/types/testIds";
import { Rounded } from "../../../../theme/Rounded";
import { Tooltip } from "../../../../utils/local-antd";
import { getWhatsappUrl } from "../../../../utils/String";

const ActionButton = styled(Button)`
  margin: 0;
  padding: 0;
  width: 2rem;
  height: 2rem;
  border-radius: ${Rounded.circle};
  background-color: ${({ theme }) => theme.sub};
  color: ${({ theme }) => theme.main};
`;

const StyledCopyButton = styled(CopyButton)`
  margin: 0 !important;
  padding: 0 !important;
  width: 2rem;
  height: 2rem;
  border-radius: ${Rounded.circle};
  background-color: ${({ theme }) => theme.sub};

  svg {
    color: ${({ theme }) => theme.main};
  }

  &:hover {
    background-color: ${({ theme }) => theme.sub};
  }
`;

type EntryDetailsContactActionsProps = {
  kind: "phone" | "email";
  value: string;
};

/** The same two actions the entries table offers on a phone or an email: reach out, or copy it. */
export const EntryDetailsContactActions: React.FC<
  EntryDetailsContactActionsProps
> = ({ kind, value }) => {
  const { t } = useTranslation();
  const isPhone = kind === "phone";

  return (
    <>
      <Tooltip
        title={t(
          isPhone
            ? "entries.table.settings.columns.whatsapp.title"
            : "entries.table.settings.columns.email.title",
        )}
      >
        <ActionButton
          icon={isPhone ? faWhatsapp : faEnvelope}
          iconWidth="lg"
          onClick={() =>
            window.open(
              isPhone ? getWhatsappUrl(value) : `mailto:${value}`,
              "_blank",
            )
          }
          dataTestId={TestIDs.entries.details.contactAction(kind)}
        />
      </Tooltip>

      <StyledCopyButton copy={value} iconSize="lg" />
    </>
  );
};
